import React, { useEffect, useState } from "react";
import { TabContext, TabPanel } from "@mui/lab";
import { Accordion, Grid, Skeleton, Tab, Tabs, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { useMediaQuery } from "@mui/material";
import MUIAccordionSummary from "@mui/material/AccordionSummary";
import MUIAccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material/styles";

const Functions = ({ functions, loading }) => {

    const medium = useMediaQuery('(max-width:999px)');

    const [value, setValue] = React.useState("0");
    const [expanded, setExpanded] = React.useState(null);

    const handleChange = (event, newValue) => {
        setValue(newValue);

        setExpanded(null);
    };

    const handleAccordionChange = (index) => (event, isExpanded) => {
        setExpanded(isExpanded ? index : false);

        setTimeout(() => {
            if (isExpanded) {
                const accordionRef = document.getElementById(`accordion-${index}`);
                if (accordionRef) {
                    accordionRef.scrollIntoView({ behavior: 'smooth' });
                }
            }
        }, 300);

    };

    return (
        <>
            {medium ? (
                <>
                    <Box
                        sx={{
                            width: '90%',
                            margin: '0 auto',
                            paddingBottom: '40px',
                        }}
                    >
                        <Typography
                            sx={{
                                color: '#265DA5',
                                textAlign: 'center',
                                fontSize: '1.5rem',
                                fontWeight: '600',
                                marginTop: '50px',
                                marginBottom: '30px',
                            }}
                        >
                            Key Features
                        </Typography>
                        {functions ? (
                            functions.map((accordion, index) => (
                                <Accordion
                                    key={index}
                                    expanded={expanded === index}
                                    onChange={handleAccordionChange(index)}
                                    sx={{ border: 'none', boxShadow: 'none', padding: '10px 0' }}
                                >
                                    <MUIAccordionSummary
                                        expandIcon={<FontAwesomeIcon icon={faArrowDown} style={{ color: '#005EAA' }} />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                        sx={{
                                            padding: '0',
                                            minHeight: '0',
                                            '& .MuiAccordionSummary-content': {
                                                margin: '0',
                                            },
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: '#005EAA',
                                                fontSize: '1.2rem',
                                                fontWeight: '600',
                                                textTransform: 'none',
                                            }}
                                            id={`accordion-${index}`}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'flex-end',
                                                    justifyContent: 'space-between',
                                                }}
                                            >
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: `
                                                            <div style="width: 40px; height: 40px; overflow: hidden; margin-bottom: -9px;">
                                                                <div style="width: 100%; height: 100%;">
                                                                    ${accordion.icon.replace(/<svg/, `<svg viewBox="0 0 50 60" preserveAspectRatio="xMidYMid meet" style="width: 100%; height: 100%;">`)}
                                                                </div>
                                                            </div>
                                                        `,
                                                    }}
                                                    style={{
                                                        marginRight: '20px',
                                                        display: 'flex',
                                                        alignItems: 'flex-end',
                                                    }}
                                                />
                                                {accordion.tab_name}
                                            </Box>
                                        </Typography>
                                    </MUIAccordionSummary>
                                    <MUIAccordionDetails
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            padding: '0',
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: '#265DA5',
                                                fontSize: '1.5rem',
                                                fontWeight: '600',
                                                marginBottom: '30px',
                                            }}
                                        >
                                            {accordion.title}
                                        </Typography>
                                        {accordion.bullets.map((bullet, index) => (
                                            <Box
                                                sx={{
                                                    marginBottom: '20px',
                                                    display: 'flex',
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faCheckCircle}
                                                    style={{
                                                        color: accordion.tab_color,
                                                        marginRight: '10px',
                                                        marginTop: '4px',
                                                    }}
                                                />
                                                <Typography
                                                    key={index}
                                                >
                                                    {bullet.bullet_text}
                                                </Typography>
                                            </Box>
                                        ))}
                                        <img src={accordion.image} alt={accordion.title} style={{ width: '100%', marginTop: '20px' }} />
                                    </MUIAccordionDetails>
                                </Accordion>
                            ))
                        ) : (
                            <Typography>No functions found</Typography>
                        )}
                    </Box>
                </>
            ) : (
                <Container maxWidth="xl"
                    sx={{
                        paddingBottom: '40px',
                    }}
                >
                    {loading ?
                        <>
                            <Skeleton
                                variant="rectangular"
                                width="100%"
                                height="45px"
                                sx={{
                                    margin: '50px auto 30px auto',
                                    maxWidth: '300px',
                                }}
                            />
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    flexWrap: 'wrap',
                                }}
                            >
                                {Array.from({ length: 5 }).map((_, index) => (
                                    <Skeleton
                                        key={index}
                                        variant="rectangular"
                                        width="15%"
                                        height="48px"
                                        sx={{
                                            marginBottom: '20px',
                                        }}
                                    />
                                ))}
                            </Box>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Skeleton variant="rectangular" width="100%" height="45px" sx={{ marginBottom: '20px' }} />
                                    <Skeleton variant="rectangular" width="100%" height="45px" sx={{ marginBottom: '20px' }} />
                                    <Skeleton variant="rectangular" width="100%" height="45px" sx={{ marginBottom: '20px' }} />
                                    <Skeleton variant="rectangular" width="100%" height="45px" sx={{ marginBottom: '20px' }} />
                                    <Skeleton variant="rectangular" width="100%" height="45px" sx={{ marginBottom: '20px' }} />
                                </Grid>
                                <Grid item xs={6}>
                                    <Skeleton variant="rectangular" width="100%" height="100%" />
                                </Grid>
                            </Grid>
                        </>
                        :
                        <Box
                            sx={{
                                width: '100%',
                                margin: '0 auto',
                            }}
                        >
                            <Typography
                                sx={{
                                    color: '#265DA5',
                                    textAlign: 'center',
                                    fontSize: '1.5rem',
                                    fontWeight: '600',
                                    marginTop: '50px',
                                    marginBottom: '30px',
                                }}
                            >
                                Key Features
                            </Typography>
                            {functions ? (
                                <TabContext value={value}>
                                    <Tabs
                                        orientation="horizontal"
                                        value={value}
                                        onChange={handleChange}
                                        sx={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            justifyContent: 'space-between',
                                            borderBottom: '1px solid #005EAA',
                                            '& .MuiTabs-indicator': {
                                                backgroundColor: '#005EAA',
                                                height: '5px',
                                            },
                                            '& .css-heg063-MuiTabs-flexContainer': {
                                                justifyContent: 'space-between',
                                            },
                                        }}
                                    >
                                        {functions.map((tab, index) => (
                                            <Tab
                                                sx={{
                                                    color: '#005EAA',
                                                    fontSize: '1.2rem',
                                                    fontWeight: '600',
                                                    textTransform: 'none',
                                                    position: 'relative',
                                                    padding: '0',
                                                    marginBottom: '15px',
                                                    '&.Mui-selected': {
                                                        color: '#005EAA',
                                                        fontWeight: '600',
                                                    },
                                                    // '&:before': {
                                                    //     display: 'block',
                                                    //     content: `'${tab.tab_icon}'`,
                                                    //     position: 'absolute',
                                                    //     left: '0',
                                                    //     height: '100px',
                                                    //     width: '60px',
                                                    // },
                                                    '&@media (max-width: 983px)': {
                                                        width: '100%',
                                                    },
                                                }}
                                                label={
                                                    <div
                                                        class="key-features-tab"
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'flex-end',
                                                        }}
                                                    >
                                                        <div
                                                            class={`tab-icon-${index}`}
                                                            dangerouslySetInnerHTML={{
                                                                __html: `
                                                                <div style="width: 40px; height: 40px; margin-bottom: -9px;">
                                                                <div style="width: 40px; height: 40px;">
                                                                ${tab.icon}
                                                                </div>
                                                            </div>
                                                                `,
                                                            }}
                                                            style={{
                                                                marginRight: '10px',
                                                                display: 'flex',
                                                                alignItems: 'flex-end',
                                                            }}
                                                        />
                                                        <span>{tab.tab_name}</span>
                                                    </div>
                                                }
                                                value={index.toString()}
                                                key={index}
                                                variant="fullWidth"
                                            >
                                            </Tab>
                                        ))}
                                    </Tabs>
                                    {functions.map((tab, index) => (
                                        <TabPanel value={index.toString()} key={index}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'flex-start',
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: '43%',
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            color: '#265DA5',
                                                            fontSize: '1.5rem',
                                                            fontWeight: '600',
                                                            marginTop: '40px',
                                                            marginBottom: '30px',
                                                        }}
                                                    >
                                                        {tab.title}
                                                    </Typography>
                                                    {tab.bullets.map((bullet, index) => (
                                                        <Box
                                                            sx={{
                                                                marginBottom: '20px',
                                                                display: 'flex',
                                                            }}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faCheckCircle}
                                                                style={{
                                                                    color: tab.tab_color,
                                                                    marginRight: '10px',
                                                                    marginTop: '4px',
                                                                }}
                                                            />
                                                            <Typography
                                                                key={index}
                                                            >
                                                                {bullet.bullet_text}
                                                            </Typography>
                                                        </Box>
                                                    ))}
                                                </Box>
                                                <img src={tab.image} alt={tab.title} style={{ width: '55%', marginTop: '20px' }} />
                                            </Box>
                                        </TabPanel>
                                    ))}
                                </TabContext>
                            ) : (
                                <Typography>No functions found</Typography>
                            )}
                        </Box>
                    }
                </Container>
            )}
        </>
    );

}

export default Functions;